
(function () {
  var GLOBAL_SEEN = {};

  function uniq(arr) {
    var out = [], seen = {};
    arr.forEach(function (u) {
      if (!u) return;
      var key = u.split('?')[0];
      if (seen[key]) return;
      seen[key] = 1;
      out.push(u);
    });
    return out;
  }

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function withWidth(src) {
    if (!src) return src;
    if (src.indexOf('width=') !== -1) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=700';
  }

  function buildImgs(el, urls) {
    el.innerHTML = '';
    urls.slice(0, 10).forEach(function (url, i) {
      var img = document.createElement('img');
      img.src = url;
      img.alt = el.getAttribute('data-title') || '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.width = 700;
      img.height = 700;
      img.className = 'motion-reduce sfl-cat-rotate__img' + (i === 0 ? ' is-active' : '');
      if (i !== 0) img.setAttribute('aria-hidden', 'true');
      el.appendChild(img);
    });
  }

  function startRotate(el) {
    if (el.dataset.sflBound) return;
    var imgs = el.querySelectorAll('.sfl-cat-rotate__img');
    if (imgs.length < 2) return;
    el.dataset.sflBound = '1';
    var i = 0;
    var ms = parseInt(el.getAttribute('data-interval') || '5000', 10);
    setInterval(function () {
      imgs = el.querySelectorAll('.sfl-cat-rotate__img');
      if (imgs.length < 2) return;
      imgs[i].classList.remove('is-active');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-active');
    }, ms);
  }

  function pickUrls(products, handle) {
    var available = [];
    var rest = [];
    products.forEach(function (p) {
      var ok = (p.variants || []).some(function (v) { return v.available; });
      var src = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0]));
      if (!src) return;
      src = withWidth(src);
      var key = src.split('?')[0];
      // lightly discourage reusing same CDN file across different tiles
      var item = { src: src, key: key, usedElsewhere: !!GLOBAL_SEEN[key] };
      if (ok) available.push(item); else rest.push(item);
    });
    var pool = available.concat(rest);
    // prefer not-used-elsewhere first
    pool.sort(function (a, b) {
      if (a.usedElsewhere === b.usedElsewhere) return 0;
      return a.usedElsewhere ? 1 : -1;
    });
    var urls = [];
    var local = {};
    pool.forEach(function (item) {
      if (local[item.key]) return;
      local[item.key] = 1;
      urls.push(item.src);
      GLOBAL_SEEN[item.key] = (GLOBAL_SEEN[item.key] || 0) + 1;
    });
    // shuffle for variety so every page load isn't same order
    urls = shuffle(uniq(urls));
    // If still thin, allow a second pass without global filter
    if (urls.length < 3) {
      urls = shuffle(uniq(pool.map(function (i) { return i.src; })));
    }
    return urls;
  }

  function loadCollection(el) {
    var handle = el.getAttribute('data-handle');
    if (!handle) {
      startRotate(el);
      return;
    }
    // request more products for variety
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=30';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        var urls = pickUrls(products, handle);
        if (urls.length) buildImgs(el, urls);
        startRotate(el);
      })
      .catch(function () { startRotate(el); });
  }

  function init(root) {
    // reset global seen per full page init so order is fresh each load
    if (!root || root === document) GLOBAL_SEEN = {};
    var nodes = (root || document).querySelectorAll('[data-sfl-rotate]');
    // stagger starts slightly so tiles don't all flip same frame
    nodes.forEach(function (el, idx) {
      setTimeout(function () { loadCollection(el); }, idx * 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
